import { createMarkup } from '@libs/utils';
import { Icon, IconColor, IconID } from '@common/Icon/Icon';

export interface InfoBoxProps {
  text: string;
}

export const InfoBox = ({ text }: InfoBoxProps) => (
  <div className="mb-8 pr-3">
    <div className="flex flex-row mt-1">
      <div className="p-1">
        <Icon id={IconID.INFO} size={7} color={IconColor.BLUE} />
      </div>
      <p className="leading-8 user-content text-xs" dangerouslySetInnerHTML={createMarkup(text)} />
    </div>
  </div>
);
